import React, { useRef, useState } from "react";
import { Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import courseService from "../../services/course.service";

const UploadResponse = ({ exerciseId, onUploadSuccess }) => {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();

  const handleUpload = async () => {
    const file = fileRef.current?.files[0];
    if (!file) {
      message.error("Veuillez sélectionner un fichier.");
      return;
    }

    try {
      setUploading(true);
         // ✅ Récupérer l'utilisateur depuis le localStorage
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user?.id;
       if (!userId) {
        message.error("Utilisateur non authentifié !");
        return;
      }
      // await courseService.uploadStudentTrainingResponse(exerciseId, file);
            await courseService.uploadStudentTrainingResponse(exerciseId, userId, file);

      message.success("Fichier envoyé avec succès !");
      onUploadSuccess?.(); // callback
    } catch (error) {
      message.error("Erreur lors de l'upload.");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <input type="file" ref={fileRef} />
      <Button
        type="primary"
        icon={<UploadOutlined />}
        loading={uploading}
        onClick={handleUpload}
      >
        Envoyer
      </Button>
    </div>
  );
};

export default UploadResponse;
